export const LOAD_PAGE_REQUESTED = 'LOAD_PAGE_REQUESTED'
export const LOAD_PAGE_DONE = 'LOAD_PAGE_DONE'
export const LOAD_PAGE_FAILED = 'LOAD_PAGE_FAILED'
